module.exports = __webpack_public_path__ + "static/media/maintenance-bg.dcb42057.jpg";